export default {"src":"/_next/static/media/metal-silver.e92ecd7f.svg","height":27,"width":32};